import axios from "axios";

import { loginRequest, msalInstance } from "./authConfig";

export async function acquireToken() {
  try {
    const accounts = msalInstance.getAllAccounts();

    if (accounts.length === 0) {
      console.warn("No user account found. Redirecting to login.");
      await msalInstance.loginRedirect(loginRequest);
      throw new Error("User not logged in. Redirecting to login.");
    }

    const silentRequest = {
      ...loginRequest,
      scopes: ["Directory.Read.All"],
      account: accounts[0],
    };

    const tokenResponse = await msalInstance.acquireTokenSilent(silentRequest);
    sessionStorage.setItem(
      "msalToken",
      tokenResponse.idToken
    );
    return `Bearer ${tokenResponse.idToken}`;
  } catch (error: any) {
    if (
      [
        "login_required",
        "monitor_window_timeout",
        "interaction_required",
        "invalid_grant",
        "user_cancelled",
        "popup_window_error",
        "token_renewal_error",
        "invalid_token",
        "token_expired",
      ].includes(error.errorCode)
    ) {
      msalInstance.acquireTokenRedirect(loginRequest);
    } else {
      console.error("Error acquiring token silently:", error);
      throw error;
    }
  }
}

const axiosInstance = axios.create({
  baseURL: `${import.meta.env.VITE_APP_API}`,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

axiosInstance.interceptors.request.use(
  async (config) => {
    try {
      config.headers["Authorization"] = await acquireToken();
    } catch (error) {
      return Promise.reject(error);
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        const accounts = msalInstance.getAllAccounts();
        if (accounts.length > 0) {
          const silentRequest = {
            ...loginRequest,
            account: accounts[0],
            forceRefresh: true,
            scopes: ["Directory.Read.All"],

          };

          const tokenResponse = await msalInstance.acquireTokenSilent(
            silentRequest
          );


          const newToken = `Bearer ${tokenResponse.accessToken}`;

          originalRequest.headers["Authorization"] = newToken;

          return axiosInstance(originalRequest);
        }
      } catch (refreshError) {
        console.error("Token refresh failed:", refreshError);
        await msalInstance.loginRedirect(loginRequest);
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;

export async function acquireAccessToken() {
  try {
    const accounts = msalInstance.getAllAccounts();

    if (accounts.length === 0) {
      console.warn("No user account found. Redirecting to login.");
      await msalInstance.loginRedirect(loginRequest);
      throw new Error("User not logged in. Redirecting to login.");
    }

    const silentRequest = {
      ...loginRequest,
      scopes: ["Directory.Read.All"],
      account: accounts[0],
    };

    const tokenResponse = await msalInstance.acquireTokenSilent(silentRequest);
    sessionStorage.setItem(
      "msalAccessToken",
      tokenResponse.accessToken
    );
    return `Bearer ${tokenResponse.accessToken}`;
  } catch (error: any) {
    if (
      [
        "login_required",
        "monitor_window_timeout",
        "interaction_required",
        "invalid_grant",
        "user_cancelled",
        "popup_window_error",
        "token_renewal_error",
        "invalid_token",
        "token_expired",
      ].includes(error.errorCode)
    ) {
      msalInstance.acquireTokenRedirect(loginRequest);
    } else {
      console.error("Error acquiring token silently:", error);
      throw error;
    }
  }
}

export const axiosAccessInstance = axios.create({
  baseURL: `${import.meta.env.VITE_APP_API}`,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

axiosInstance.interceptors.request.use(
  async (config) => {
    try {
      config.headers["Authorization"] = await acquireAccessToken();
    } catch (error) {
      return Promise.reject(error);
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        const accounts = msalInstance.getAllAccounts();
        if (accounts.length > 0) {
          const silentRequest = {
            ...loginRequest,
            account: accounts[0],
            forceRefresh: true,
            scopes: ["Directory.Read.All"],

          };

          const tokenResponse = await msalInstance.acquireTokenSilent(
            silentRequest
          );


          const newToken = `Bearer ${tokenResponse.accessToken}`;

          originalRequest.headers["Authorization"] = newToken;

          return axiosInstance(originalRequest);
        }
      } catch (refreshError) {
        console.error("Token refresh failed:", refreshError);
        await msalInstance.loginRedirect(loginRequest);
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

